import { ViewMetadata } from '@eplant/View'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
const GetStartedView: ViewMetadata = {
  name: 'Get started',
  id: 'get-started',
  icon: () => <HomeOutlinedIcon />,
}

export default GetStartedView
